import { useState, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { QRCodeCanvas } from 'qrcode.react';

const QR_ITEMS = [
  {
    id: 'site',
    label: '홈페이지',
    url: 'https://knb-ent.com',
    description: '카메라로 스캔하면\n홈페이지로 이동합니다',
    downloadName: 'KNB_홈페이지_QR코드.png',
    color: '#1a2744',
  },
  {
    id: 'blog',
    label: '네이버 블로그',
    url: 'https://blog.naver.com/bluez2955',
    description: '카메라로 스캔하면\n네이버 블로그로 이동합니다',
    downloadName: 'KNB_블로그_QR코드.png',
    color: '#000000',
  },
];

export default function QRCodeWidget() {
  const [expanded, setExpanded] = useState(false);
  const [activeTab, setActiveTab] = useState<'site' | 'blog'>('site');
  const canvasRef = useRef<HTMLDivElement>(null);
  const location = useLocation();

  // 홈페이지('/')에서는 표시하지 않음
  if (location.pathname === '/') return null;

  const current = QR_ITEMS.find((item) => item.id === activeTab)!;

  const handleDownload = () => {
    const canvas = canvasRef.current?.querySelector('canvas');
    if (!canvas) return;
    const url = canvas.toDataURL('image/png');
    const a = document.createElement('a');
    a.href = url;
    a.download = current.downloadName;
    a.click();
  };

  return (
    <div className="fixed bottom-6 left-6 z-50 flex flex-col items-start gap-2">
      {expanded && (
        <div className="bg-white rounded-2xl shadow-2xl border border-gray-100 p-4 flex flex-col items-center gap-3 w-52">
          {/* Tab Switcher */}
          <div className="w-full flex bg-gray-100 rounded-full p-1">
            {QR_ITEMS.map((item) => (
              <button
                key={item.id}
                onClick={() => setActiveTab(item.id as 'site' | 'blog')}
                className={`flex-1 py-1 text-xs font-semibold rounded-full transition-all cursor-pointer whitespace-nowrap ${
                  activeTab === item.id
                    ? 'bg-white text-gray-800 shadow-sm'
                    : 'text-gray-400 hover:text-gray-600'
                }`}
              >
                {item.label}
              </button>
            ))}
          </div>

          <p className="text-xs font-semibold text-gray-500 tracking-wide">{current.label} 바로가기</p>

          <div ref={canvasRef} className="rounded-xl overflow-hidden border border-gray-100 p-2 bg-white">
            <QRCodeCanvas
              value={current.url}
              size={160}
              fgColor={current.color}
              bgColor="#ffffff"
              level="H"
            />
          </div>

          <p className="text-[11px] text-gray-400 text-center leading-relaxed whitespace-pre-line">
            {current.description}
          </p>

          <button
            onClick={handleDownload}
            className="w-full flex items-center justify-center gap-1.5 py-2 bg-gray-900 text-white rounded-lg text-xs font-medium hover:bg-gray-700 transition-all whitespace-nowrap cursor-pointer"
          >
            <i className="ri-download-2-line text-sm"></i>
            QR 이미지 저장
          </button>
        </div>
      )}

      <button
        onClick={() => setExpanded((prev) => !prev)}
        className="w-12 h-12 bg-white rounded-full shadow-xl border border-gray-100 flex items-center justify-center hover:scale-105 transition-all cursor-pointer"
        title="QR코드 보기"
      >
        {expanded ? (
          <i className="ri-close-line text-gray-700 text-xl"></i>
        ) : (
          <i className="ri-qr-code-line text-gray-700 text-xl"></i>
        )}
      </button>
    </div>
  );
}
